import(/* webpackMode: "eager" */ "/home/circleci/project/corgi/src/common/assets/icons/favicon/favicon.ico");
;
import(/* webpackMode: "eager", webpackExports: ["GrowthBookTracking","GrowthBookClient"] */ "/home/circleci/project/corgi/src/common/growthbook/components/GrowthBookClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/home/circleci/project/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/PageApp-Purchase/src/components/signup/body/RegistrationBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/PageApp-Purchase/src/components/signup/SignupPage.tsx");
